import { render } from "./Fileuploading.vue?vue&type=template&id=ccb2097a&scoped=true"
import script from "./Fileuploading.vue?vue&type=script&lang=js"
export * from "./Fileuploading.vue?vue&type=script&lang=js"

import "./Fileuploading.vue?vue&type=style&index=0&id=ccb2097a&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb2097a"]])

export default __exports__